import React from 'react';
import {useDispatch} from "react-redux";
import {useRouter} from "next/router";

// components
import {Button} from "@material-ui/core";

// actions
import { toggleDrawer } from '~/slices/commons/drawer'
import { setSearchType, setSearchPreset } from '~/slices/items/itemSearchOption'
import { setPage } from '~/slices/items/itemPaginate'

// resources
import { presetHealthCondition } from '~/data/shop/itemSearchPreset'

export const HealthCondition = (props) => {
  const { searchType } = props
  const dispatch = useDispatch()
  const router = useRouter()

  const searchPreset = (value) => {
    dispatch(setSearchType(searchType))
    dispatch(setSearchPreset(value))
    dispatch(toggleDrawer({openFlg: false, key: 'search'}))

    const pathname = '/items/'
    router.push(pathname)
  }

  return (
      <div>
        <ul>
          {
            presetHealthCondition.list.map((item, index) => (
                <li key={index}>
                  <Button onClick={() => searchPreset({
                    title: presetHealthCondition.label,
                    healthCondition: item.code
                  })}>
                    {
                      item.label
                    }
                  </Button>
                </li>
            ))
          }
        </ul>
      </div>
  );
};
